import React from 'react';
const DateIcon = () => {
return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.37402 0C4.7192 0 4.99902 0.279822 4.99902 0.625V1.25H14.999V0.625C14.999 0.279822 15.2788 0 15.624 0C15.9692 0 16.249 0.279822 16.249 0.625V1.25H17.499C18.8797 1.25 19.999 2.36929 19.999 3.75V17.5C19.999 18.8807 18.8797 20 17.499 20H2.49902C1.11831 20 -0.000976562 18.8807 -0.000976562 17.5V3.75C-0.000976562 2.36929 1.11831 1.25 2.49902 1.25H3.74902V0.625C3.74902 0.279822 4.02885 0 4.37402 0ZM2.49902 2.5C1.80867 2.5 1.24902 3.05964 1.24902 3.75V17.5C1.24902 18.1904 1.80867 18.75 2.49902 18.75H17.499C18.1894 18.75 18.749 18.1904 18.749 17.5V3.75C18.749 3.05964 18.1894 2.5 17.499 2.5H2.49902Z"
            fill="#343A40"/>
        <path
            d="M3.12402 5C3.12402 4.65482 3.40385 4.375 3.74902 4.375H16.249C16.5942 4.375 16.874 4.65482 16.874 5V6.25C16.874 6.59518 16.5942 6.875 16.249 6.875H3.74902C3.40385 6.875 3.12402 6.59518 3.12402 6.25V5Z"
            fill="#343A40"/>
    </svg>

)

}
export default DateIcon;
